import type { Message } from '../domain/chat'
import { replyingTo$ } from '../store'

// UI-level actions for a message. These orchestrate local/observable state, not
// business rules; mutations (delete, send) still go through application use-cases.
const useMessageActions = () => {
	const setReplyTarget = (message: Message) => replyingTo$.set(message)

	return { setReplyTarget }
}

export { useMessageActions }
